<template>
  <p class="markdown markdown-body" :style="size" v-html="compileMarkdown(message)" />
</template>

<script>
import Md from "markdown-it";
import Mk from "@iktakahiro/markdown-it-katex";
import Mv from "markdown-it-video";
import { sanitizeHtmlWithIframeRestriction } from '@/utils/sanitizer';

export default {
  props: {
    message: {
      required: true,
      type: String
    },
    width: {
      type: Number,
      default: null
    },
    height: {
      type: Number,
      default: null
    }
  },
  data: () => {
    return {
      markdown: {
        youtube: {
          width: 640,
          height: 390,
        },
      },
      defaultValue: "-",
    };
  },
  computed: {
    size() {
      return {
        ...(!!this.height && {
          height: `${this.height}px`
        }),
        ...(!!this.width && {
          width: `${this.width}px`
        })
      };
    }
  },
  methods: {
    compileMarkdown(markdownText) {
      if (markdownText === null || markdownText === undefined) {
        return this.defaultValue;
      }
      if (typeof markdownText === "string") {
        let markdownRendered = Md({
          html: true,
          linkify: true,
          typographer: true,
          breaks: true,
        })
          .use(Mk)
          .use(Mv, {
            youtube: {
              width: this.markdown.youtube.width,
              height: this.markdown.youtube.height,
            },
          })
          .render(markdownText);

        return sanitizeHtmlWithIframeRestriction(markdownRendered);
      }
      return markdownText;
    },
  }
};
</script>

<style>

.markdown .katex .katex-html{
  display: none;
}

.markdown img {  
  max-width: 400px !important;
  width: 100% !important;
  height: auto !important;
}

.markdown iframe {  
  width: 560px !important;
  height: 315px !important;
}
</style>